/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-else-return */
/* eslint-disable arrow-parens */
/* eslint-disable indent */
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { projectTitleInitialState } from '../reducers/project-title';
import downloadBlob from '../lib/download-blob';
// import $ from  'jquery'


/** 
* Asynchronously uploading 
*/
// asyncUpload(bucketName, objectKey, filepath,options) { 
//         return RNAliyunOSS.asyncUpload(bucketName, objectKey, filepath,options); 
// } 

// AliyunOSS.initWithServerSTS(server,endpoint,configuration);
/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3Downloader>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3Downloader>
 */
//文件上传的功能
class Fileossupload extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'saveworksCallback',
            'handleSubmitToTeacher'
        ]);
    }
    //保存作品的回调
    saveworksCallback(type, projectName) {
        this.props.saveProjectSb3().then(content => {
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            // downloadBlob(this.props.projectFilename, content);
            //const url = window.URL.createObjectURL(content);
            this.uploadfile(this.props.projectFilename, content, type, projectName);
        });

    }
    //提交给老师
    handleSubmitToTeacher(record, domain, accessToken) {
        fetch(`${domain}/api/programs/studentChangeStatus?access_token=${accessToken}`, {
            method: 'POST',
            body: JSON.stringify({ id: record.id }),
            headers: {
                'content-type': 'application/json'
            },
        })
            .then((response) => response.json())
            .then((res) => {
                if (res.error) {
                    throw res;
                }
                if (res.success) {
                    alert('提交成功');
                }
            })
            .catch((error) => {
                if (error.error) {
                    alert(error.error.message);
                } else {
                    alert(error);
                }
            });
    }
    render() {
        const {
            children
        } = this.props;
        // console.log("this.props", this.props)
        return children(
            this.props.className,
            this.saveworksCallback
        );
    }
    //远程服务器保存文件的方法
    uploadfile(name, content, type = '', projectName) {
        //动态创建表单对象
        let _search = location.search;
        location._query = {};
        location._query['lang'] = 'en';
        let queryArray = [];
        if (_search) {
            _search = _search.replace('?', '');
            queryArray = _search.split('&');
            for (var i = 0; i < queryArray.length; i++) {
                location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
            }
        }
        let accessToken = location._query['accessToken'];
        let lessonId = location._query['lessonId'];
        let resourceId = location._query['resourceId'];
        let promotionId = location._query['promotionId'];
        let lessonCodeId = location._query['lessonCodeId'];
        let plat = location._query['plat'];
        let programId = location._query['programId'];
        console.log('location._query==>', location._query);
        let domain = location._query['domain'] || 'https://coursedev.e-ai-edu.com';

        let formData = new FormData();
        let fileName = projectName ? `${projectName.substring(0, 100)}.sb3` : name;
        formData.append("file", content, fileName);
        formData.append("name", fileName);
        formData.append("accessToken", accessToken);
        if (resourceId) {
            formData.append("resourceId", resourceId);
        } else if (lessonId) {
            formData.append("lessonId", lessonId);
        } else if (promotionId) {
            formData.append("promotionId", promotionId);
        }
        if (lessonCodeId) {
            formData.append("lessonCodeId", lessonCodeId);
        }
        if (programId) {
            formData.append("programId", programId);
        }

        console.log(plat);
        const url = plat == 'platc' ? `${domain}/api/programs/saveSb3` : `${domain}/api/programs/saveSb3`;

        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then((response) => response.json())
            .then((responseJsonData) => {
                if (responseJsonData.error) {
                    throw responseJsonData;
                }
                if (responseJsonData.success && type != 1) {
                    alert('文件已保存到平台云端');
                }
                return responseJsonData.data;
            }).then(data => {
                console.log("data", data);
                type == 1 && this.handleSubmitToTeacher(data, domain, accessToken);
            })
            .catch((error) => {
                console.error('saveSb3 error ', error);
                if (error.error) {
                    alert(error.error.message);
                } else {
                    alert(error);
                }
            });
    }
}



function downfile(filename, blob) {
    var downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    // Use special ms version if available to get it working on Edge.
    // var blob = new Blob([blob]);
    var url = window.URL.createObjectURL(blob);
    downloadLink.href = url;
    console.log(url);
    downloadLink.download = filename;
    downloadLink.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(downloadLink);

}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

Fileossupload.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func
};
Fileossupload.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

// export default AliyunOSS = { 
//     initWithServerSTS(server, endPoint, configuration = conf) { 
//     RNAliyunOSS.initWithServerSTS(server, endPoint, configuration); 
// } 
export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(Fileossupload);
